import { render, staticRenderFns } from "./UpdateUserDrawer.vue?vue&type=template&id=1afe8b25"
import script from "./UpdateUserDrawer.vue?vue&type=script&lang=js"
export * from "./UpdateUserDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports